// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3JguU","paramInput":"JobSimulator_paramInput__2D6uw","input":"JobSimulator_input__2uX5O"};